import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LanguageModule } from '@language';
import {
    ShActionItemComponent,
    ShHtmlParserComponent,
    ShIconModule,
    ShLayoutModule,
    ShNotificationComponent,
    ShPageHeaderComponent,
    ShScrollspyNavComponent
} from '@stylehaven/components';
import { SharedElementsModule } from '../elements/shared/shared-elements.module';
import { DisclaimerBannerContainerComponent } from './containers/disclaimer-banner/disclaimer-banner-container.component';
import { DisclaimerContainerComponent } from './containers/disclaimer/disclaimer-container.component';
@NgModule({
    imports: [
        CommonModule,
        ShIconModule,
        ShActionItemComponent,
        ShPageHeaderComponent,
        ShLayoutModule,
        SharedElementsModule,
        ShNotificationComponent,
        ShHtmlParserComponent,
        ShScrollspyNavComponent,
        LanguageModule
    ],
    exports: [DisclaimerBannerContainerComponent, DisclaimerContainerComponent],
    declarations: [DisclaimerBannerContainerComponent, DisclaimerContainerComponent]
})
export class DisclaimerModule {}

export { DisclaimerBannerContainerComponent } from './containers/disclaimer-banner/disclaimer-banner-container.component';
export { DisclaimerContainerComponent } from './containers/disclaimer/disclaimer-container.component';
